<template>
  <transition name="modal-fade">
    <div>
      <span v-show="isModalVisible">
        <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
          <header class="modal-header" id="modalTitle">
            <slot name="header">
              {{ i18nJS.pai_end }}
              <button type="button" class="btn-close" @click="close" aria-label="Close modal">
                <i class="fa-light fa-xmark"></i>
              </button>
            </slot>
          </header>
          <section class="modal-body" id="modalDescription">
            <slot name="body">
              <div v-if="currentGuestFullName" class="text-sapn">
                {{ completamento }} <i>{{ currentGuestFullName }}</i>
              </div>
              <div v-if="currentGuestFullName && guestEndPeriodType == 'rsaa'" class="text-sapn">
                Tipo Dimissione: <i>Completamento del PAI</i>
              </div>
              <div v-if="currentGuestFullName && guestEndPeriodType != 'siad'" class="text-sapn">
                <span>
                  {{ dataCompletamento }}
                </span>
                <span class="piker-sapn">
                  <datepicker class="input_date" v-model="endDate" required="required" />
                  <timepicker v-model="endTime" required="required" />
                </span>
              </div>
              <div class="form-inline check_container">
                <label v-if="guestEndPeriodType == 'siad'" for="one" class="inline">
                  <input type="radio" value="renewal_profile" v-model="newGpds" v-on:change="changeDate" />
                  Rinnovo Profilo
                </label>
                <label for="two" class="inline">
                  <input type="radio" value="new_gpds" v-model="newGpds" v-on:change="changeDate" />
                  {{ nuovo }}
                </label>
                <label v-if="guestEndPeriodType != 'siad'" for="three" class="inline">
                  <input type="radio" value="end_gpds" v-model="newGpds" />
                  Fine Rapporto
                </label>
              </div>
              <div v-if="newGpds == 'new_gpds'">
                <div class="new-pai-pikers">
                  <span class="text-sapn">
                    {{ dataNuovo }}
                  </span>
                  <span class="piker-sapn">
                    <datepicker class="input_date" v-model="startDate" required="required" />
                    <timepicker v-model="startTime" required="required" />
                  </span>
                </div>
                <span v-if="errorDate" class="span-error">
                  Errore sulle Date, non può iniziare un periodo prima che finisca il precedente
                </span>
              </div>
              <div v-if="newGpds == 'end_gpds'">
                <div class="new-pai-pikers">
                  <span class="text-sapn">
                    {{ dataCompletamento }}
                  </span>
                  <span class="piker-sapn">
                    <datepicker class="input_date" v-model="endDate" required="required" />
                    <timepicker v-model="endTime" required="required" />
                  </span>
                </div>
              </div>
              <div v-if="newGpds == 'renewal_profile' && guestEndPeriodType == 'siad'">
                <div class="new-pai-pikers">
                  <span class="text-sapn"> Data Rinnovo: </span>
                  <span class="piker-sapn">
                    <datepicker class="input_date" v-model="startDate" required="required" />
                    <timepicker v-model="startTime" required="required" />
                  </span>
                </div>
                <div class="text-sapn">
                  <span> Durata Prevista: </span>
                  <span class="piker-sapn">
                    <input type="number" v-model.number="previewDuration" />
                  </span>
                </div>
              </div>
            </slot>
          </section>
          <footer class="modal-footer">
            <slot name="footer">
              <div v-if="newGpds != null">
                <i v-show="loading" class="far fa-spinner fa-spin" />
                <button type="button" @click="saveEndGpds" class="btn btn-success save-btn" aria-label="Save modal">
                  {{ i18nJS.command.save }}
                </button>
              </div>
            </slot>
          </footer>
        </div>
        <div class="modal-backdrop"></div>
      </span>
      <!-- MODAL NEW VALUTATION -->
      <div aria-labelledby="myModalLabel" class="modal valutation-popup" role="dialog" v-show="isModalValutationVisible">
        <header class="modal-header">
          {{ i18nJS.new_valutation }}
          <button type="button" class="btn-close" @click="close" aria-label="Close modal">
            <i class="fa-light fa-xmark"></i>
          </button>
        </header>
        <div class="modal-body">
          {{ i18nJS.valutation_choice }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" @click="valutationNow" aria-label="Save modal">
            {{ i18nJS.valutation_now }}
          </button>
          <button type="button" class="btn btn-primary" @click="reloadPage" aria-label="Save modal">
            {{ i18nJS.valutation_after }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
export default {
  name: 'rsaaEndPai',
  components: {
    datepicker,
    timepicker,
  },
  props: [
    'targetModal',
    'currentGuestFullName',
    'endPaiUserUrl',
    'guestStatusId',
    'guestValutationUrl',
    'guestEndPeriodType',
    'siad1Id',
    'remainingDays',
    'isSacraFamiglia',
  ],
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {
      previewDuration: 90,
      gpds_id: null,
      errorDate: false,
      endDate: null,
      endTime: null,
      startTime: null,
      startDate: null,
      newGpds: null,
      loading: false,
      isModalVisible: false,
      isModalValutationVisible: false,
      completamento: '',
      dataCompletamento: '',
      nuovo: '',
      dataNuovo: '',
    };
  },
  mounted() {
    if (this.guestEndPeriodType == 'rsaa') {
      this.completamento = 'Completamento PAI di:';
      this.dataCompletamento = 'Data/Ora Completamento PAI:';
      this.nuovo = 'Nuovo PAI';
      this.dataNuovo = 'Data/Ora Inizio Nuovo PAI:';
    }
    if (this.guestEndPeriodType == 'dom') {
      this.completamento = 'Rinnovo Voucher per:';
      this.dataCompletamento = 'Data/Ora scadenza Voucher:';
      this.nuovo = 'Nuovo Voucher';
      this.dataNuovo = 'Data/Ora Inizio Nuovo Voucher:';
    }
    if (this.guestEndPeriodType == 'siad') {
      this.dataCompletamento = 'Data/Ora fine Periodo:';
      this.completamento = 'Cambio/Chiusura Profilo per:';
      this.nuovo = 'Cambio Profilo';
      this.dataNuovo = 'Data/Ora Inizio Nuovo Profilo:';
    }
    this.errorDate = false;
    this.endDate = moment().format(i18nJS.time.formats.date_only);
    this.endTime = this.guestEndPeriodType == 'rsaa' && this.isSacraFamiglia ? '23:59' : moment().format('HH:mm');

    $("[data-toggle = 'end-pai'], [data-target = '" + this.targetModal + "']").click(() => {
      this.isModalVisible = true;
    });

    eventBus.$on('openModalRsaaAndPai', (data) => {
      this.isModalVisible = true;
    });
  },
  watch: {
    endDate: {
      immediate: true,
      handler(newVal) {
        this.startDate = moment(newVal, 'DD-MM-YYYY').add(1, 'day').format('L');
      },
    },
    endTime: {
      immediate: true,
      handler(newVal) {
        this.startTime = moment('2012-01-01 ' + newVal, '%Y-%m-%d H:mm')
          .add(1, 'minutes')
          .format('HH:mm');
      },
    },
    startDate: {
      handler(newVal) {
        this.errorDate = false;
        var dataTimeEnd = moment(this.endDate + this.endTime, i18nJS.time.formats.aux);
        var dataTimeStart = moment(newVal + this.startTime, i18nJS.time.formats.aux);
        if (dataTimeEnd >= dataTimeStart && this.guestEndPeriodType != 'siad') {
          this.errorDate = true;
        }
      },
    },
    startTime: {
      handler(newVal) {
        this.errorDate = false;
        var dataTimeEnd = moment(this.endDate + this.endTime, i18nJS.time.formats.aux);
        var dataTimeStart = moment(this.startDate + newVal, i18nJS.time.formats.aux);
        if (dataTimeEnd >= dataTimeStart && this.guestEndPeriodType != 'siad') {
          this.errorDate = true;
        }
      },
    },
  },
  methods: {
    changeDate() {
      if (this.guestEndPeriodType == 'siad' && this.newGpds == 'renewal_profile') {
        this.startDate = moment(this.startDate, 'DD-MM-YYYY').add(this.remainingDays, 'days').format('L');
      } else {
        this.startDate = moment(new Date(), 'DD-MM-YYYY').add(1, 'day').format('L');
      }
    },
    close() {
      this.loading = false;
      this.errorDate = false;
      $('.save-btn').prop('disabled', false);
      this.endDate = moment().format(i18nJS.time.formats.date_only);
      this.endTime = moment().format('HH:mm');
      this.newGpds = null;
      this.isModalVisible = false;
      this.isModalValutationVisible = false;
    },
    saveEndGpds() {
      if (this.errorDate && (this.newGpds == 'new_gpds' || this.newGpds == 'renewal_profile')) {
        alert('correggere le date prima di salvare');
      } else {
        this.error = false;
        $('.save-btn').prop('disabled', true);
        this.loading = true;
        var link = this.endPaiUserUrl;
        var params = {
          guest_status_id: this.guestStatusId,
          end_period_date: this.endDate,
          end_period_time: this.endTime,
        };
        if (this.newGpds == 'new_gpds' || this.newGpds == 'renewal_profile') {
          if (this.guestEndPeriodType == 'siad') {
            if (this.newGpds == 'new_gpds') {
              params['change_profile'] = true;
              params['duration_preview'] = 0;
            } else {
              params['change_profile'] = false;
              params['duration_preview'] = this.previewDuration;
            }
            link = `/${window.locale}/siad1s/${this.siad1Id}/siad4s.json`;
          }
          params['start_new_period_date'] = this.startDate;
          params['start_new_period_time'] = this.startTime;
        }
        apiConnector()
          .post(link, params)
          .then((res) => {
            this.gpds_id = res.data.gpds_id;
            this.loading = false;
            if (this.newGpds == 'new_gpds' && this.guestEndPeriodType != 'siad') {
              this.isModalValutationVisible = true;
            } else {
              if (this.guestEndPeriodType == 'siad') {
                if (this.newGpds == 'new_gpds') {
                  this.close();
                  window.location.replace(this.guestValutationUrl);
                } else {
                  window.location.reload();
                }
              } else {
                this.reloadPage;
              }
            }
          })
          .catch((err) => {
            let errorIndex = 1;
            const errors = Object.keys(err.response.data).map((k) => `${errorIndex++}: ${err.response.data[k].toString()}`);
            alert('Impossibile effettuare la registrazione, errore: ' + errors.join('\n').toString());
            this.loading = false;
            this.error = true;
          });
      }
    },
    valutationNow() {
      this.close();
      window.location.replace(this.guestValutationUrl.replace(/guest_period_data_sets\/(\d+)/, 'guest_period_data_sets/' + this.gpds_id));
    },
    reloadPage() {
      this.close();
      var url = window.location.href.replace(/guest_period_data_sets\/(\d+)/, 'guest_period_data_sets/' + this.gpds_id);
      window.location.replace(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.save-btn {
  float: right;
}
.check_container {
  margin-top: 20px;
  label {
    input {
      margin: 0px 0px;
    }
    padding: 5px;
    margin-bottom: 0px;
  }
  text-align: center;
  padding: 2px;
}
.vmodal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  left: 25%;
  width: 50%;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}
.modal-header {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  color: #ef7b12;
  justify-content: space-between;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}
.modal-body {
  position: relative;
  padding: 20px 10px;
}
.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #ef7b12;
  background: transparent;
}
.new-pai-pikers {
  margin-top: 5%;
}
.text-sapn {
  margin-top: 2%;
  margin-left: 5%;
}
.piker-sapn {
  margin-right: 5%;
  float: right;
}
.graycolor {
  color: #999;
}
.blackcolor {
  color: #0000;
}
.span-error {
  font-size: 13px;
  color: red;
  margin-left: 29px;
}
.valutation-popup {
  width: 30%;
  left: 35%;
}
input[type='number'] {
  float: right;
  width: 50px;
}
</style>
